import { atom } from 'jotai';
import { unwrap } from 'jotai/utils';
import { locationAtom } from '@/atoms/location';
import { isMetricMappedAtom } from '@/atoms/metric/metricFilterMapping';
import { teamEventMetricFiltersAtom } from '@/atoms/queries/team/teamEventData';
import { selectedVisualisationAtom } from '@/atoms/visualisation';

const TEAM_VIS_PATH = /^\/[^/]+\/team\/[^/]+\/vis(\/|$)/;

// the debounced team params only carry the perspective on the team vis page, but they outlive it
const isTeamVisAgainstAtom = atom(
  get => TEAM_VIS_PATH.test(get(locationAtom).pathname) && get(teamEventMetricFiltersAtom)?.perspective === 'against',
);

// the event map and heat map draw mirrored data only for a mapped metric
export const isEventsCropSwappedAtom = atom(get => get(isTeamVisAgainstAtom) && get(isMetricMappedAtom));

// the visualisations that draw the mirrored markers, so the crop selector and wrapper swap only for these
const CROP_SWAPPED_VISUALISATION_KEYS: readonly string[] = ['eventMap', 'heatMap', 'passSonar'];

// the default visualisation loads from the API, so nothing is swapped until the selection is known
const unwrappedSelectedVisualisationAtom = unwrap(selectedVisualisationAtom);

export const isSelectedVisualisationCropSwappedAtom = atom(get => {
  const selectedKey = get(unwrappedSelectedVisualisationAtom)?.visualisationKey;
  return get(isEventsCropSwappedAtom) && !!selectedKey && CROP_SWAPPED_VISUALISATION_KEYS.includes(selectedKey);
});
